import { Component, ElementRef, Inject, ViewChild, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import {ItemDetail} from '@emm/core/models/item-detail.model';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';

@Component({
  selector: 'emm-add-submenu-dialog',
  templateUrl: './add-submenu-dialog.component.html',
  styleUrls: ['./add-submenu-dialog.component.scss']
})
export class AddSubmenuDialogComponent implements OnInit {

    addGlobal: FormControl = new FormControl();
    displayAddGlobal = false;
    emergencyTag: string;
    errorMessage: string;
    input: FormControl = new FormControl();
    id: FormControl = new FormControl();
    name: FormControl = new FormControl();
    copyFromId: FormControl = new FormControl();
    isReadOnly$ = this.authFacade.isReadOnly$;
    items: Array<ItemDetail> = [];
    options: Array<any>;
    tagExists = false;
    visible = true;
    saveDisabled = false;

    @ViewChild('itemInput') itemInput: ElementRef<HTMLInputElement>;

    constructor(
        private authFacade: AuthFacadeService,
        public dialogRef: MatDialogRef<AddSubmenuDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.emergencyTag = data.emergencyTag || null;
    }


    ngOnInit() {
        this.options = this.data.submenus;
    }


    displayFn(option): string | undefined {
        return option ? option.name : undefined;
    }


    cancelAddItem(): void {
        this.dialogRef.close();
    }


    addItem(): void {
        const result = {
            addGlobal: this.addGlobal.value || false,
            value: this.items,
            newSubmenu: {
                name: this.name.value,
                id: this.id.value,
                copyFromId: this.copyFromId.value ? this.copyFromId.value : '',
            }
        };
        this.dialogRef.close(result);
    }


    isSaveDisabled(): boolean {
        this.saveDisabled = (this.id.value === null || this.name.value === null);
        return this.saveDisabled;
    }

    submenuTagValidation() {
        const pattern = new RegExp( /^[A-Z0-9_]+$/);
        if (pattern.test(this.id.value)) {
            return this.id.setErrors(null);
        } else {
            return this.id.setErrors({pattern: true, message: ''});
        }
    }

}
